/* eslint-disable no-undef */
import { ItemRegex } from './../global-constants';

const lowerCaseFirst = string => {
	return string.charAt(0).toLowerCase() + string.slice(1);
};

const convertItemVariablesAttrs = (originalValue, vehicle) => {
	let testString = originalValue;
	let reConvert = false;
	if (typeof testString === 'object') {
		testString = JSON.stringify(testString, null, true);
		reConvert = true;
	}
	if (ItemRegex.test(testString)) {
		testString = testString.replace(ItemRegex, (orig, _item, field) => {
			const itemProperty = lowerCaseFirst(field);
			return field && vehicle[itemProperty]
				? vehicle[itemProperty]
				: orig;
		});
	}
	return !reConvert ? testString : JSON.parse(testString);
};

export default convertItemVariablesAttrs;



// WEBPACK FOOTER //
// ./src/utils/vehicle.js